import { render, staticRenderFns } from "./dtlMain.vue?vue&type=template&id=aab0b004&scoped=true"
import script from "./dtlMain.vue?vue&type=script&lang=js"
export * from "./dtlMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aab0b004",
  null
  
)

export default component.exports